import Constants from "../utils/params";
export function handleErrors(response)
{
    if (!response.ok) {
        throw (response);
    }
    return response.json();
}


export function getCompanyBySiret(siret)
{
    const token = localStorage.getItem("id_token")
    let params = {
        headers: {'Authorization': "bearer " + token}
    };

    return fetch(`${Constants.DOMAIN}/api/company/` + siret + '/infos', params)
        .then(handleErrors)
        .then(res=>res)
        .catch((err)=>{
            return err;
        })
}


// WEBPACK FOOTER //
// ./src/api/company.js